module.exports = __webpack_public_path__ + "static/media/Group 7628.6f67b64c.svg";